/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Form_LabelInputs */

const en_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker Management`)
};

const fr_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des marqueurs`)
};

const de_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markerverwaltung`)
};

const it_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione dei marcatori`)
};

const ru_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление маркерами`)
};

const es_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de marcadores`)
};

const zh_cn2_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记管理`)
};

const ja_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカー管理`)
};

const hi_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर प्रबंधन`)
};

const pt_pt2_markers_form_label = /** @type {(inputs: Markers_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de Marcadores`)
};

/**
* | output |
* | --- |
* | "Marker Management" |
*
* @param {Markers_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_form_label = /** @type {((inputs?: Markers_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_form_label(inputs)
	if (locale === "de") return de_markers_form_label(inputs)
	if (locale === "it") return it_markers_form_label(inputs)
	if (locale === "ru") return ru_markers_form_label(inputs)
	if (locale === "es") return es_markers_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_form_label(inputs)
	if (locale === "ja") return ja_markers_form_label(inputs)
	if (locale === "hi") return hi_markers_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_form_label(inputs)
	return en_markers_form_label(inputs)
});